<template>
    <div>
        <loading
            :active.sync="loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link
                    :to="{
                        name: 'home',
                    }"
                    class="headerButton"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">
                {{
                    selectGroupSpecial.length > 0
                        ? selectGroupSpecial[0].group_name
                        : 'Loading...'
                }}
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Form -->

            <!-- List Operator -->
            <div class="section mt-2">
                <div class="text-center" v-if="loading.list_operator">
                    <span
                        class="spinner-border spinner-border-sm mr-1"
                        role="status"
                        aria-hidden="true"
                    ></span>
                </div>

                <!-- Style Operator "LIST" -->
                <div class="transactions" v-else-if="operator.length > 0">
                    <!-- item -->
                    <a
                        href="javascript:;"
                        v-for="itemOperator in operator"
                        :key="itemOperator.id"
                        class="item"
                        :class="
                            lockProduct(itemOperator) ? 'disabled-product' : ''
                        "
                        style="padding: 10px"
                        @click="selectOperator(itemOperator)"
                    >
                        <div class="detail">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    itemOperator.icon
                                        ? VUE_ENV.VUE_APP_ASSET_URL +
                                          '/img/icon/operator/' +
                                          itemOperator.icon
                                        : require('@/assets/Loader-2.png')
                                "
                                alt="image"
                                class="image-block imaged"
                                style="width: 50px"
                            />
                            <div style="color: #17273e">
                                <header style="margin-bottom: 5px">
                                    <div class="badge badge-promo pl-2 pr-2">
                                        {{
                                            itemOperator.prabayar_category
                                                .product_name
                                        }}
                                    </div>
                                </header>
                                <b style="font-weight: bold">{{
                                    itemOperator.product_name
                                }}</b>
                                <footer>
                                    <small>{{
                                        itemOperator.description
                                    }}</small>
                                </footer>
                            </div>
                        </div>

                        <div class="right">
                            <div class="icon">
                                <ion-icon
                                    name="chevron-forward-outline"
                                ></ion-icon>
                            </div>
                        </div>
                    </a>
                    <!-- * item -->
                </div>

                <div class="text-center mt-3" v-else-if="!loading.content">
                    <img
                        :src="require('@/assets/image/empty.webp')"
                        alt="empty"
                        class="w-75"
                    /><br />
                    <h2 class="mb-0">Belum Ada Data</h2>
                    <p>Tidak ada data yang dapat ditampilkan</p>
                </div>
            </div>
        </div>

        <action-sheet
            ref="information_verification"
            :title="'Informasi'"
            :inset="false"
        >
            <div class="text-center">
                <img
                    :src="require('@/assets/verification_rejected.png')"
                    alt="Verifikasi dalam proses"
                    class="w-50"
                /><br />
            </div>
            <div class="text-center p-2">
                <h3 class="mb-0">Anda belum melengkapi data diri</h3>
                <p class="mb-0">Yuk, segera langkapi sekarang</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block"
                    @click="hideInformationVerification(true)"
                >
                    Lengkapi Data Diri
                </button>
                <button
                    class="btn btn-outline-primary btn-block"
                    @click="hideInformationVerification(false)"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import $axios from './../../../../api.js';
    import { mapState } from 'vuex';
    export default {
        props: ['toast_reference'],
        data() {
            return {
                loading: {
                    content: true,
                    list_operator: false,
                },
                operator: [],
            };
        },
        created() {
            this.getOperator();
            // window.fbq('track', 'ViewContent');
        },
        computed: {
            ...mapState([
                'customer',
                'toast',
                'VUE_ENV',
                'device',
                'categoryPrabayar',
                'groupProductSpecial',
            ]),
            selectGroupSpecial() {
                return this.groupProductSpecial.filter(item => {
                    return item.id == this.$route.params.id;
                });
            },
        },
        methods: {
            lockProduct(item) {
                if (
                    item.lock_product == 'YES' &&
                    (this.customer.account_verified_data == null ||
                        this.customer.account_verified_data.status !=
                            'APPROVED')
                ) {
                    return true;
                } else {
                    return false;
                }
            },
            selectOperator(data) {
                if (this.lockProduct(data)) {
                    this.showInformationVerification();
                } else {
                    this.$router.push({
                        name: 'prabayar-special-order',
                        params: {
                            id: data.id, // operator id
                            operator_selected: data, // operator detail,
                            group_id: this.$route.params.id,
                        },
                    });
                }
            },
            getOperator() {
                this.operator = [];
                $axios
                    .get('/prabayar/product-special/operator', {
                        params: {
                            group_id: this.$route.params.id,
                        },
                    })
                    .then(response => {
                        if (response.data.data.length > 0) {
                            this.operator = response.data.data;
                            this.loading.list_operator = false;
                            this.loading.content = false;
                        } else {
                            this.operator = [];
                            this.loading.list_operator = false;
                            this.loading.content = false;
                        }
                    })
                    .catch(e => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: e.response.data.message,
                            tipe: 'default',
                        });
                        this.loading.list_operator = false;
                        this.loading.content = false;
                    });
            },
            showInformationVerification() {
                let element = this.$refs.information_verification.$el;
                window.$(element).modal('show');
            },
            hideInformationVerification(redirect) {
                let element = this.$refs.information_verification.$el;
                window.$(element).modal('hide');
                if (redirect) {
                    this.$router.push({ name: 'account.data-diri' });
                }
            },
        },
        mounted() {
            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.showStatus();
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 500);
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
